import { render, staticRenderFns } from "./ExtraButtonEditProperties.vue?vue&type=template&id=33c8529f&"
import script from "./ExtraButtonEditProperties.vue?vue&type=script&lang=ts&"
export * from "./ExtraButtonEditProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c8529f')) {
      api.createRecord('33c8529f', component.options)
    } else {
      api.reload('33c8529f', component.options)
    }
    module.hot.accept("./ExtraButtonEditProperties.vue?vue&type=template&id=33c8529f&", function () {
      api.rerender('33c8529f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/ExtraButtonEditProperties.vue"
export default component.exports